import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import MessageGroupForm from './messageGroupForm';
import CardWrapper from '@components/Card/CardWrapper';
import { UpdateMessageGroupInput } from '../../types/accountsGlobalTypes';

interface IRTable {
  title?: string;
  TableAction?: React.ReactNode;
  bulkDeleteProducts?: () => void;
  handleSubmit: (payload: UpdateMessageGroupInput) => void;
  isLoading: boolean;
  item: UpdateMessageGroupInput;
}

const EditMessageGroup: React.FC<IRTable> = ({ handleSubmit, isLoading, item }) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
            <Formik
              onSubmit={async (values: any) => handleSubmit(values)}
              initialValues={{name: item.name, description: item.description}}
              validateOnChange={true}
            >
              {(formBag) => (
                <MessageGroupForm
                  formBag={
                    (formBag as unknown) as FormikProps<UpdateMessageGroupInput>
                  }
                  disableLoginButton={isLoading}
                />
              )}
            </Formik>
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default EditMessageGroup;
